import { createAction, createActionGroup, props } from '@ngrx/store';

export const genericErrorAction = createAction(
  '[APP] GENERIC_ERROR',
  props<{ message?: string }>()
);

export const applicationActions = createActionGroup({
  source: '[ APPLICATION ]',
  events: {
    'generic error': props<{ message?: string }>(),
    'generic success': props<{ message: string }>()
  }
});
